import React from 'react';

const MONTHS_FULL = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
const ymd = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;

// Свой календарь переноса: название месяца всегда видно, листание месяцев ничего не сохраняет — дата ставится только по нажатию на день
export default function RescheduleCalendar({ value, onPick, onClose }) {
  const today = new Date(); today.setHours(0,0,0,0);
  const cur = value ? new Date(String(value).slice(0,10)+'T00:00:00') : today;
  const [view, setView] = React.useState(new Date(cur.getFullYear(), cur.getMonth(), 1));
  const shift = n => setView(v => new Date(v.getFullYear(), v.getMonth()+n, 1));
  const first = (view.getDay()+6)%7;
  const days = new Date(view.getFullYear(), view.getMonth()+1, 0).getDate();
  const cells = [...Array(first).fill(null), ...Array.from({length:days}, (_,i)=>new Date(view.getFullYear(), view.getMonth(), i+1))];
  const plus = n => { const d = new Date(today); d.setDate(d.getDate()+n); return ymd(d); };
  const nav = {width:36,height:36,borderRadius:8,border:'1px solid var(--border)',background:'var(--bg-hover)',color:'var(--text)',fontSize:18,cursor:'pointer'};
  const quick = {flex:1,padding:'7px 4px',borderRadius:8,border:'1px solid var(--border)',background:'var(--bg-hover)',color:'var(--text)',fontSize:12,cursor:'pointer'};
  return (
    <div onClick={e=>{e.stopPropagation();onClose();}} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.35)',zIndex:300,display:'flex',alignItems:'center',justifyContent:'center',padding:12}}>
      <div onClick={e=>e.stopPropagation()} style={{width:'100%',maxWidth:320,background:'var(--bg-surface)',border:'1px solid var(--border)',borderRadius:12,padding:14,boxShadow:'0 8px 32px rgba(0,0,0,0.25)'}}>
        <div style={{fontSize:12,color:'var(--text-muted)',marginBottom:8}}>Перенести на:</div>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
          <button style={nav} onClick={()=>shift(-1)} title="Предыдущий месяц">‹</button>
          <div style={{flex:1,textAlign:'center',fontWeight:700,fontSize:16,color:'var(--text)'}}>{MONTHS_FULL[view.getMonth()]} {view.getFullYear()}</div>
          <button style={nav} onClick={()=>shift(1)} title="Следующий месяц">›</button>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:3,textAlign:'center'}}>
          {['Пн','Вт','Ср','Чт','Пт','Сб','Вс'].map(w => <div key={w} style={{fontSize:11,color:'var(--text-muted)',padding:'2px 0'}}>{w}</div>)}
          {cells.map((d,i) => d ? (
            <button key={i} onClick={()=>onPick(ymd(d))}
              style={{height:36,borderRadius:8,cursor:'pointer',fontSize:14,
                border: d.getTime()===today.getTime() ? '2px solid var(--accent)' : '1px solid transparent',
                background: d.getTime()===cur.getTime() ? 'var(--accent)' : 'transparent',
                color: d.getTime()===cur.getTime() ? '#fff' : d < today ? 'var(--text-muted)' : 'var(--text)',
                fontWeight: d.getTime()===cur.getTime() ? 700 : 400}}>{d.getDate()}</button>
          ) : <div key={i} />)}
        </div>
        <div style={{display:'flex',gap:6,marginTop:12}}>
          <button style={quick} onClick={()=>onPick(plus(0))}>Сегодня</button>
          <button style={quick} onClick={()=>onPick(plus(1))}>Завтра</button>
          <button style={quick} onClick={()=>onPick(plus(7))}>Через неделю</button>
        </div>
        <button onClick={onClose} style={{display:'block',width:'100%',marginTop:8,padding:6,fontSize:12,color:'var(--text-muted)',background:'none',border:'none',cursor:'pointer'}}>Отмена</button>
      </div>
    </div>
  );
}
